export const name = (project, phasecode) =>
  `${project.name} (${project.project_job_no})/${phasecode?.name} ${
    phasecode?.code ? `(${phasecode.code})` : '-'
  }`;
